import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { KycComponent } from './kyc/kyc.component';
import { KycPdfComponent } from './kyc-pdf/kyc-pdf.component';
import { KycListComponent } from './kyc-list/kyc-list.component';

const routes: Routes = [
  {
    path: '',
    component: KycComponent
  },
  {
    path: 'kyc',
    component: KycComponent
  },
  {
    path: 'kyc-details',
    component: KycPdfComponent
  },
  {
    path: 'kyc-list',
    component: KycListComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class KycRoutingModule { }
